module.exports = __webpack_public_path__ + "img/icon-maxsize.5026e7fe.svg";